var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "",
    viewBox: "10.02 34.3 80.03 31.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M89.3,62.6l-12.7-9.1V36c0-0.9-0.7-1.7-1.7-1.7h-8.9c-0.9,0-1.7,0.7-1.7,1.7v8.7L51,35c0,0,0,0-0.1,0  c-0.1,0-0.1-0.1-0.2-0.1c0,0-0.1,0-0.1-0.1c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.1,0  c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0.1c0,0-0.1,0.1-0.1,0.1c0,0,0,0-0.1,0  L10.7,62.6c-0.7,0.5-0.9,1.6-0.4,2.3c0.3,0.4,0.8,0.7,1.4,0.7c0.3,0,0.7-0.1,1-0.3l37.4-27l15.1,10.9l8.9,6.4l13.4,9.6  c0.3,0.2,0.6,0.3,1,0.3c0.5,0,1-0.2,1.4-0.7C90.2,64.2,90.1,63.2,89.3,62.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cdcce8d031456ce2acedabeef8c5127e.svg";
export { ForwardRef as ReactComponent };